// extracted by mini-css-extract-plugin
export var label = "_j6-0";
export var treatmentCard = "_j6-1";